<template>
    <v-form ref="search-customer" id="search-customer" @submit.prevent="search">
        <v-text-field
            solo
            dense
            clearable
            class="compact"
            v-model="query"
            prepend-icon="mdi-magnify"
            :label="$t('components.SearchCustomers.SearchLabel')"
            @click:clear="$emit('cleared')">
        </v-text-field>
    </v-form>
</template>

<script>

/**
 * SearchCustomers component is a visual component that displays a search form
 * to filter customers.
 */
export default {
    name: 'SearchCustomers',
    data: () => ({
        query: null
    }),
    methods: {
        search() {
            this.$emit("search", this.query);
        }
    }
}
</script>

<style>
    .compact .v-text-field__details { display: none!important; }
</style>